class LocationManager {
    static US = "US";
  
    constructor() {
      this.geoLocation = undefined;
      this.#getGeoLocation();
    }
  
    async isInUS() {
      const location = await this.#getGeoLocation();
      return location == LocationManager.US;
    }
  
    async #getGeoLocation() {
      // Memoize
      if (this.geoLocation !== undefined) {
        return this.geoLocation;
      }
  
      this.geoLocation = LocationManager.US;
      try {
        const countryResponse = await fetch(
          window.Shopify.routes.root +
            "browsing_context_suggestions.json?country[enabled]=true"
        );
  
        const countryData = await countryResponse.json();
        // countryData.detected_values.country.handle will be the ISO country code
        // e.g., "US" for USA
        if (countryData.detected_values && countryData.detected_values.country) {
          this.geoLocation = countryData.detected_values.country.handle;
        }
      } catch (error) {
        console.warn("Error getting geo location:", error);
      }
      
      console.log(this.geoLocation);
      return this.geoLocation;
    }
  }
  
  class ModalState {
    static HSA = "hsa";
    static UPSELL = "upsell";
  }
  
  class PDPElementManager {
    static #MODAL = "membership-upgrade";
    static #MODAL_TITLE = "membership-upgrade-title";
    static #MODAL_DESCRIPTION = "membership-upgrade-text";
    static #MODAL_BUTTON = "membership-upgrade-button";
    static #MODAL_SKIP = "membership-upgrade-button-skip";
    static #MODAL_CLOSE = "membership-upgrade-content-close";
    static #MODAL_BUTTON_TEXT = "membership-upgrade-button-text";
    static #CART_DRAWER = "cart-drawer";
  
    constructor(prefix, options = {}) {
      this.prefix = prefix || "";
      this.middleSegment = options.middleSegment || "";
    }
  
    #buildSelector(baseName) {
      if (this.middleSegment) {
        // For product-card-custom: .neckband-product-card-custom-membership-upgrade
        return `.${this.prefix}-${this.middleSegment}-${baseName}`;
      } else {
        // For main-product-custom: .main-product-custom-membership-upgrade
        return `.${this.prefix}-${baseName}`;
      }
    }
  
    get modal() {
      return this.#buildSelector(PDPElementManager.#MODAL);
    }
  
    get modalTitle() {
      return this.#buildSelector(PDPElementManager.#MODAL_TITLE);
    }
  
    get modalDescription() {
      return this.#buildSelector(PDPElementManager.#MODAL_DESCRIPTION);
    }
  
    get modalButton() {
      return this.#buildSelector(PDPElementManager.#MODAL_BUTTON);
    }
  
    get modalSkip() {
      return this.#buildSelector(PDPElementManager.#MODAL_SKIP);
    }
  
    get modalClose() {
      return this.#buildSelector(PDPElementManager.#MODAL_CLOSE);
    }
  
    get modalButtonText() {
      return this.#buildSelector(PDPElementManager.#MODAL_BUTTON_TEXT);
    }
  
    get cartDrawer() {
      return PDPElementManager.#CART_DRAWER;
    }
  }
  
  class PDPModalManager {
    constructor(
      elementPrefix,
      monthlyProductId,
      monthlySellingPlanId,
      annualProductId,
      annualSellingPlanId,
      hsaMonthlyProductId,
      hsaAnnualProductId,
      hsaMonthlySellingPlanId,
      hsaAnnualSellingPlanId,
      upgradeHeadingText,
      upgradePrice,
      options = {},
      hsa_fsa_provider = "none",
      checkoutUrl,
    ) {
      const { middleSegment = "", formSelector = null } = options;
  
      this.elementManager = new PDPElementManager(elementPrefix, {
        middleSegment,
      });
      this.locationManager = new LocationManager();
      this.modalMode = undefined;
      this.formSelector = formSelector;
  
      this.monthlyProductId = monthlyProductId;
      this.monthlySellingPlanId = monthlySellingPlanId;
      this.annualProductId = annualProductId;
      this.annualSellingPlanId = annualSellingPlanId;
      this.hsaMonthlyProductId = hsaMonthlyProductId;
      this.hsaAnnualProductId = hsaAnnualProductId;
      this.hsaMonthlySellingPlanId = hsaMonthlySellingPlanId;
      this.hsaAnnualSellingPlanId = hsaAnnualSellingPlanId;
      this.upgradeHeadingText = upgradeHeadingText;
      this.upgradePrice = upgradePrice;
      this.hsa_fsa_provider = hsa_fsa_provider;
      
      this.checkoutUrl = checkoutUrl;
      this.checkoutUrl = "/cart";
      
      this.hsaFlow = false;
  
      // Auto-setup form listener if formSelector is provided
      if (this.formSelector) {
        this.setupFormListener();
      }

      this._boundHandleAccept = this.#handleModalAcceptClick.bind(this);
      this._boundHandleDecline = this.#handleModalDeclineClick.bind(this);
      this._boundHandleClose = this.#handleModalCloseClick.bind(this);

      console.log(hsa_fsa_provider);
    }
  
    setupFormListener() {
      const form = document.querySelector(this.formSelector);
      if (form) {
        form.addEventListener("submit", (e) => this.showModal(e, form));
      }
    }
  
    // Factory method for main product custom
    static createForMainProduct(
      monthlyProductId,
      monthlySellingPlanId,
      annualProductId,
      annualSellingPlanId,
      hsaMonthlyProductId,
      hsaAnnualProductId,
      hsaMonthlySellingPlanId,
      hsaAnnualSellingPlanId,
      upgradeHeadingText,
      upgradePrice,
      hsa_fsa_provider,
      checkoutUrl
    ) {
      return new PDPModalManager(
        "main-product-custom",
        monthlyProductId,
        monthlySellingPlanId,
        annualProductId,
        annualSellingPlanId,
        hsaMonthlyProductId,
        hsaAnnualProductId,
        hsaMonthlySellingPlanId,
        hsaAnnualSellingPlanId,
        upgradeHeadingText,
        upgradePrice,
        {
          middleSegment: "",
          formSelector: ".main-product-custom-buy-button-form-container",
        },
        hsa_fsa_provider,
        checkoutUrl
      );
    }
  
    // Factory method for product cards
    static createForProductCard(
      productType,
      monthlyProductId,
      monthlySellingPlanId,
      annualProductId,
      annualSellingPlanId,
      hsaMonthlyProductId,
      hsaAnnualProductId,
      hsaMonthlySellingPlanId,
      hsaAnnualSellingPlanId,
      upgradeHeadingText,
      upgradePrice,
      hsa_fsa_provider,
      checkoutUrl
    ) {
      return new PDPModalManager(
        productType, // e.g., 'neckband', 'sleeppad'
        monthlyProductId,
        monthlySellingPlanId,
        annualProductId,
        annualSellingPlanId,
        hsaMonthlyProductId,
        hsaAnnualProductId,
        hsaMonthlySellingPlanId,
        hsaAnnualSellingPlanId,
        upgradeHeadingText,
        upgradePrice,
        {
          middleSegment: "product-card-custom",
          formSelector: `.${productType}-product-card-custom__instant-checkout-form`,
        },
        hsa_fsa_provider,
        checkoutUrl
      );
    }
  
    async showModal(e, form) {
      e.preventDefault();
      e.stopPropagation();
  
      if (this.#shouldBlockSubmission()) {
        return;
      }
  
      if (form) {
        const clickedButton = e.submitter;
        clickedButton.disabled = true;
        clickedButton.classList.add("loading");

        const formData = new FormData(form);
        const addResponseDevice = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json" },
        });

        await this.#addToCart(this.monthlyProductId, this.monthlySellingPlanId);
  
        clickedButton.disabled = false;
        clickedButton.classList.remove('loading');

        if (!addResponseDevice.ok) {
          console.warn("Device not added.");
          this.#hideModal();
          return;
        }
        
      }
  
      this.#updateCartUI();
      document.querySelector(this.elementManager.modal).style.display = "flex";
  
      if (await this.#isHsaModalMode()) {
        this.modalMode = ModalState.HSA;
        this.#showHsaModal();
      } else {
        this.modalMode = ModalState.UPSELL;
        this.#showUpsellModal();
      }
    }
  
    #showHsaModal() {
      const t = window.ShopifyTranslations?.hsaModal;
      if (!t) return;

      document.querySelector(this.elementManager.modalTitle).innerHTML = t.title;
      document.querySelector(this.elementManager.modalDescription).innerHTML =
        t.description;
      document.querySelector(this.elementManager.modalButtonText).innerHTML =
        t.button;

      this.#setupModalButtonListeners();
    }

    #showUpsellModal() {
      const t = window.ShopifyTranslations?.sellModal;
      if (!t) return;

      document.querySelector(this.elementManager.modalTitle).innerHTML =
        this.upgradeHeadingText;

      const description = t.descriptionTemplate.replace(
        "{{ price }}",
        this.upgradePrice
      );

      document.querySelector(this.elementManager.modalDescription).innerHTML =
        description;
      document.querySelector(this.elementManager.modalButtonText).innerHTML =
        t.button;

      this.#setupModalButtonListeners();
    }
  
    #setupModalButtonListeners() {
      const modalAcceptButton = document.querySelector(
        this.elementManager.modalButton
      );
      const modalSkipButton = document.querySelector(
        this.elementManager.modalSkip
      );
      const modalCloseButton = document.querySelector(
        this.elementManager.modalClose
      );
  
      modalAcceptButton?.removeEventListener(
        "click",
        this._boundHandleAccept
      );
      modalSkipButton?.removeEventListener(
        "click",
        this._boundHandleDecline
      );
      modalCloseButton?.removeEventListener(
        "click",
        this._boundHandleClose
      );
  
      modalAcceptButton?.addEventListener(
        "click",
        this._boundHandleAccept
      );
      modalSkipButton?.addEventListener(
        "click",
        this._boundHandleDecline
      );
      modalCloseButton?.addEventListener(
        "click",
        this._boundHandleClose
      );
    }
  
    async #handleModalAcceptClick(e) {
      e.preventDefault();
      e.stopPropagation();
  
      if (this.#shouldBlockSubmission()) {
        return;
      }
  
      const buttonTextContainer = document.querySelector(
        this.elementManager.modalButtonText
      );
      const buttonText = buttonTextContainer.innerHTML;
      buttonTextContainer.innerHTML = "";
  
      const clickedButton = document.querySelector(
        this.elementManager.modalButton
      );
      clickedButton.disabled = true;
      clickedButton.classList.add("loading");

      const lastModalMode = this.modalMode;
  
      try {
        if (this.modalMode === ModalState.HSA) {
          await this.#handleHsaAcceptClick();
        } else if (this.modalMode === ModalState.UPSELL) {
          await this.#handleUpsellAcceptClick();
        }
      } catch (error) {
        console.warn(`${lastModalMode} accept event failed:`, error);
      }
  
      clickedButton.disabled = false;
      clickedButton.classList.remove("loading");
      buttonTextContainer.innerHTML = buttonText;
    }
  
    async #handleHsaAcceptClick() {
      const updates = {};
      updates[this.monthlyProductId] = 0;
      await this.#updateCart(updates);
      
      
      if (this.hsa_fsa_provider === "sika") {

        await this.#addToCart(
          this.hsaMonthlyProductId,
          this.hsaMonthlySellingPlanId
        );

        this.#updateCartUI();
        
        this.hsaFlow = true;
        this.modalMode = ModalState.UPSELL;
        this.#showUpsellModal();

      } else {
        
        this.#updateCartUI();
        this.hsaFlow = false;
        window.location.href = this.checkoutUrl;
        this.#hideModal();
      }
    }
  
    async #handleUpsellAcceptClick() {
      await this.#upgradeMonthlyToAnnualSubscription();
      this.#updateCartUI();
  
      window.location.href = this.checkoutUrl;
      this.#hideModal();
    }
  
    async #handleModalDeclineClick(e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.#shouldBlockSubmission()) {
        return;
      }

      if (this.modalMode === ModalState.UPSELL) {
        this.#handleUpsellDeclineClick();
      } else if (this.modalMode === ModalState.HSA) {
        await this.#handleHsaDeclineClick();
      }
    }
  
    async #handleHsaDeclineClick() {

      this.hsaFlow = false;
      this.modalMode = ModalState.UPSELL;
      this.#showUpsellModal();
      return;
    }
  
    #handleUpsellDeclineClick() {
      window.location.href = this.checkoutUrl;
      this.#hideModal();
    }
  
    #handleModalCloseClick(e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.#shouldBlockSubmission()) {
        return;
      }
      this.hsaFlow = false;
      this.#hideModal();
    }
  
    async #upgradeMonthlyToAnnualSubscription() {
      const updates = {};
      updates[
        this.hsaFlow ? this.hsaMonthlyProductId : this.monthlyProductId
      ] = 0;
  
      const annualProductId = this.hsaFlow
        ? this.hsaAnnualProductId
        : this.annualProductId;
      const annualSellingPlanId = this.hsaFlow
        ? this.hsaAnnualSellingPlanId
        : this.annualSellingPlanId;
  
      await this.#updateCart(updates);
      await this.#addToCart(annualProductId, annualSellingPlanId);
    }
  
    async #updateCart(updates) {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ updates }),
      });
    }
  
    async #addToCart(productId, sellingPlanId) {
      const formData = new FormData();
  
      formData.append("id", productId);
      formData.append("quantity", 1);
      formData.append("selling_plan", sellingPlanId);
  
      await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" },
      });
    }
  
    async #isHsaModalMode() {
      const isHsaSubscriptionAvailable = await this.#isHsaSubscriptionAvailable();
      return (
        (this.modalMode === undefined || this.modalMode === ModalState.HSA) &&
        isHsaSubscriptionAvailable
      );
    }
  
    async #isHsaSubscriptionAvailable() {
      return this.hsa_fsa_provider != "none" && this.locationManager.isInUS();
    }
  
    #shouldBlockSubmission() {
      // Block submission if any submit button is disabled or loading
      const selectors = [
        ".main-product-custom button",
        ".product-card-custom__instant-checkout-form button",
        `${this.elementManager.modal} button`,
      ];
  
      const anyLoadingOrDisabled = selectors.some((selector) => {
        const buttons = document.querySelectorAll(selector);
        return Array.from(buttons).some(
          (btn) => btn.disabled || btn.classList.contains("loading")
        );
      });
  
      return anyLoadingOrDisabled;
    }
  
    #hideModal() {
      document.querySelector(this.elementManager.modal).style.display = "none";
      this.modalMode = undefined;
    }
  
    async #updateCartUI() {
      try {
        const cartDrawer = document.querySelector(this.elementManager.cartDrawer);
        if (!cartDrawer) {
          console.warn("Cart RR failed due to Cart Drawer Not Found");
          return;
        }
  
        const response = await fetch(
          window.location.pathname + "?sections=cart-drawer,cart-icon-bubble"
        );
  
        const sections = await response.json();
        if (typeof cartDrawer.renderContentsWithoutOpening === "function") {
          console.log("Cart RR");
          cartDrawer.renderContentsWithoutOpening({ sections });
        }
      } catch (error) {
        console.warn("Cart re-render failed:", error);
      }
    }
  }
  